export const buildQuery = obj => {
  return Object.keys(obj).reduce((query, key) => {
    if (Array.isArray(obj[key])) {
      obj[key].forEach(el => query += `&${key}=${el}`)
      return query
    } else if (obj[key] || [false, 0].includes(obj[key])) {
      return query += `&${key}=${obj[key]}`
    }
    return query
  }, "").replace("&", "?")
}
